import React from "react";
import { Link } from "react-router-dom";
import { LogoMark } from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="mt-12 sm:mt-16 border-t border-[var(--border)]">
      <div className="max-w-[1440px] mx-auto px-3 sm:px-5 lg:px-8 py-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2">
            <div className="flex items-center gap-2.5">
              <LogoMark size={24} />
              <span className="font-display font-extrabold tracking-[-0.03em] text-[var(--text)] text-[15px]">
                DEX<span className="text-[var(--accent)]">.</span>
              </span>
            </div>
            <p className="mt-3 text-[12.5px] text-[var(--text-muted)] max-w-sm leading-relaxed">
              A non-custodial DEX aggregator. Best route, cross-chain, on-chain.
            </p>
          </div>
          <div>
            <div className="text-[10.5px] uppercase tracking-widest text-[var(--text-subtle)] font-mono mb-3">Product</div>
            <ul className="space-y-2 text-[12.5px] text-[var(--text-muted)]">
              <li><Link to="/" className="hover:text-[var(--text)]">Swap</Link></li>
              <li><a href="/#markets" className="hover:text-[var(--text)]">Markets</a></li>
              <li><a href="/#activity" className="hover:text-[var(--text)]">Activity</a></li>
              <li><a href="/#networks" className="hover:text-[var(--text)]">Networks</a></li>
            </ul>
          </div>
          <div>
            <div className="text-[10.5px] uppercase tracking-widest text-[var(--text-subtle)] font-mono mb-3">Resources</div>
            <ul className="space-y-2 text-[12.5px] text-[var(--text-muted)]">
              <li><Link to="/docs" className="hover:text-[var(--text)]">Documentation</Link></li>
              <li><a href="/docs#security" className="hover:text-[var(--text)]">Security</a></li>
              <li><a href="/docs#faq" className="hover:text-[var(--text)]">FAQ</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[11px] text-[var(--text-subtle)] font-mono">
          <div>© {new Date().getFullYear()} DEX — non-custodial DEX aggregator</div>
          <div className="flex items-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-[var(--up)] live-dot" />
            All systems operational
          </div>
        </div>
      </div>
    </footer>
  );
}
